import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { BaseRepo, BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import {
    GenericScanExclusion,
    ScanExclusionDomainsIds,
} from '../types/scan-exclusions.type';
import { CollectionInterface } from '@monsido/angular-shared-components';
import { DEFAULT_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { DEFAULT_PAGE } from '@client/app/shared-modules/api/constants/page.constant';
import { contextTokens } from '@monsido/services/request-auxiliary/request-auxiliary.service';


@Injectable({
    providedIn: 'root',
})
export class ScanExclusionsRepo extends BaseRepo {
    constructor (
        private apiService: ApiService,
        protected sessionService: SessionService,
    ) {
        super();
    }

    getScanExclusions (scanExcludeId: GenericScanExclusion['id']): Promise<GenericScanExclusion> {
        return this.apiService.get('source_code_excludes/' + scanExcludeId, undefined, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    getAllScanExclusions (
        params: BaseRepoRequestType = { page: DEFAULT_PAGE, page_size: DEFAULT_PAGE_SIZE },
        module: string,
    ): Promise<CollectionInterface<GenericScanExclusion>> {
        const apiParams = {
            ...params, module,
        };
        return this.apiService.get<CollectionInterface<GenericScanExclusion>>('source_code_excludes', apiParams, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    createScanExclusions (scanExcludeData: GenericScanExclusion): Promise<GenericScanExclusion> {
        return this.apiService.post('source_code_excludes', scanExcludeData, contextTokens.REDESIGN_ERROR_ALERT)
            .then((obj: unknown) => {
                const created = obj as GenericScanExclusion;
                if (scanExcludeData?.domains?.length) {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.addScanExclusionDomains(created.id, { ids: scanExcludeData.domains, exclude_id: created.id! });
                }
                return created;
            });
    }

    updateScanExclusions (updatedScanExcludeData: GenericScanExclusion): Promise<void> {
        return this.apiService.patch('source_code_excludes/' + updatedScanExcludeData.id, updatedScanExcludeData, undefined, contextTokens.REDESIGN_ERROR_ALERT)
            .then(() => {
                if (updatedScanExcludeData.id) {
                    this.addScanExclusionDomains(updatedScanExcludeData.id, { ids: updatedScanExcludeData.domains, exclude_id: updatedScanExcludeData.id });
                }
            });
    }

    getScanExclusionDomains (scanExcludeId: GenericScanExclusion['id']): Promise<Array<{ id: number }>> {
        return this.apiService.get('source_code_excludes/' + scanExcludeId + '/domains', undefined, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    addScanExclusionDomains (scanExcludeId: GenericScanExclusion['id'], domains: ScanExclusionDomainsIds): Promise<void> {
        return this.apiService.patch('source_code_excludes/' + scanExcludeId + '/domains', domains, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    destroyScanExclusions (scanExcludeId: GenericScanExclusion['id']): Promise<void> {
        return this.apiService.delete('source_code_excludes/' + scanExcludeId, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }
}
